import { ActionCreatorWithPayload, createAction } from "@reduxjs/toolkit";

/**
 *
 */
export namespace HeaderAction {

  export const toggleMenu: ActionCreatorWithPayload<boolean> = createAction('TOGGLE_MENU');
}